/* eslint-disable */
<template>    
    <v-container :class="!showSearchBox?'pb-1 pt-1 pl-0 ml-0 pr-0 mr-0 fluid scroll-target':'pb-1 pt-1 fluid scroll-target'">
        <v-layout row v-show="showSearchBox">
            <v-flex md2 xs4>
                <v-switch
                :label="isMobile? 'Rnd Trip':helper.uiCaption.getUiCaption('3C4E7130-3BA8-4A53-9AC9-20AE470926AD')"
                color="primary"
                v-model="searchPara.trip"
                @change="loadoneway()"
                :disabled="showMulticity"
                ></v-switch>
            </v-flex>
            <v-flex md2 xs4>
                <v-switch
                label="Multi-City"
                color="primary"
                v-model="multicityselection"
                           
                @change="loadmulticity()"
                ></v-switch>
            </v-flex>  
            <v-spacer></v-spacer>
            <v-flex md2 xs4 class="text-xs-right">
                <v-btn-toggle style="background:transparent;margin-top:15px;" multiple>
                    <v-btn flat class="" :href="backToHomeUrl"><v-icon>home</v-icon>{{isMobile?"":"Home"}}</v-btn>
                    <v-btn flat :disabled="copyLinkButton" @click="copyLink" class=""><v-icon>link</v-icon>{{isMobile?"":" Copy Link"}}</v-btn>
                </v-btn-toggle>
            </v-flex>            
        </v-layout>
        <SearchBox v-if="!showMulticity"
            v-scroll="onScroll"
            :SelectedLanguage="selLang" 
            @FlightFares="f=>updateFlightFaresFromSearchBox(f)" 
            @PassengerCountsByType="c=>passengerCountsByType=c" 
            @ResponseMessage="r=>responseMessage=r"
            @AirlinesForFiltering="a=>airlinesForFiltering=a"
            @LoadingAirlines="l=>loadingAirlines=l"
            @PriceMinMaxForFiltering="m=>priceMinMaxForFiltering=m"
            @SearchId="s=>searchId=s"
            @ShowSearchBox="s=>showSearchBox=s"            
            :P_WholesaleId="wholesaleId"
            :P_UrlId="urlId"
            :P_SearchCriteriaBase64="searchCriteriaBase64"
            :P_MarkupLevel="mlv"
            :P_TripType="searchPara.trip"
            />
            <MulticityBox v-if="showMulticity"
            v-scroll="onScroll"
            :SelectedLanguage="selLang" 
            @FlightFares="f=>updateFlightFaresFromSearchBox(f)" 
            @PassengerCountsByType="c=>passengerCountsByType=c" 
            @ResponseMessage="r=>responseMessage=r"
            @AirlinesForFiltering="a=>airlinesForFiltering=a"
            @LoadingAirlines="l=>loadingAirlines=l"
            @PriceMinMaxForFiltering="m=>priceMinMaxForFiltering=m"
            @SearchId="s=>searchId=s"
            @SearchPara="a=>searchPara=a"
            @ShowSearchBox="s=>showSearchBox=s"
            :P_WholesaleId="wholesaleId"
            :P_UrlId="urlId"
            :P_SearchCriteriaBase64M="searchCriteriaBase64M"
            />
        <v-layout row>
            <v-flex v-if="showSideFilteringPanel()" md3>
                <SideFilteringPanel v-if="!showMulticity"
                    :Airlines="airlinesForFiltering"
                    :LoadingAirlines="loadingAirlines"
                    :LowestPrice="priceMinMaxForFiltering[0]"
                    :HighestPrice="priceMinMaxForFiltering[1]"
                    @SelectedAirlines="a=>selectedAirlines=a"
                    @RouteIndicator="r=>routeIndicator=r"
                    @PriceRange="p=>totalPriceFiltering=p"
                    @OutboundDepartureTimeRange="t=>outboundDepartureTimeFiltering=getDepartureTimeFiler(t)"
                    @ReturnDepartureTimeRange="t=>returnDepartureTimeFiltering=getDepartureTimeFiler(t)"
                    @FlightDuration="d=>flightDurationFiltering=d"
                />
                    <SideFilteringPanelMulticity v-if="showMulticity"
                    :Airlines="airlinesForFiltering"
                    :LoadingAirlines="loadingAirlines"
                    :LowestPrice="priceMinMaxForFiltering[0]"
                    :HighestPrice="priceMinMaxForFiltering[1]"
                    @SelectedAirlines="a=>selectedAirlines=a"
                    @RouteIndicator="r=>routeIndicator=r"
                    @PriceRange="p=>totalPriceFiltering=p"
                    @OutboundDepartureTimeRange="t=>outboundDepartureTimeFiltering=getDepartureTimeFiler(t)"
                    @ReturnDepartureTimeRange="t=>returnDepartureTimeFiltering=getDepartureTimeFiler(t)"
                    @FlightDuration="d=>flightDurationFiltering=d"
                />
            </v-flex>
            <v-flex xs12 md9>
                <v-container v-if="showAlert">
                <v-alert
                    :value="showAlert"
                    type="error"
                >{{responseMessage}}</v-alert>   
                </v-container> 
                <!-- <v-container v-if="showbtnAlert">
                <v-alert :value="validation.showAlert" type="error">{{validation.message}}</v-alert>
                </v-container>  -->
                <v-expansion-panel v-if="!showSideFilteringPanel()"
                v-model="mfilterPanel"
                expand
                >
                    <v-expansion-panel-content>
                        <template v-slot:actions>
                            <v-icon color="primary">tune</v-icon>
                        </template>
                        <template v-slot:header>
                        <div>Filter</div>
                        </template>
                <SideFilteringPanel v-if="!showMulticity"
                    :Airlines="airlinesForFiltering"
                    :LoadingAirlines="loadingAirlines"
                    :LowestPrice="priceMinMaxForFiltering[0]"
                    :HighestPrice="priceMinMaxForFiltering[1]"
                    @SelectedAirlines="a=>selectedAirlines=a"
                    @RouteIndicator="r=>routeIndicator=r"
                    @PriceRange="p=>totalPriceFiltering=p"
                    @OutboundDepartureTimeRange="t=>outboundDepartureTimeFiltering=getDepartureTimeFiler(t)"
                    @ReturnDepartureTimeRange="t=>returnDepartureTimeFiltering=getDepartureTimeFiler(t)"
                    @FlightDuration="d=>flightDurationFiltering=d"
                />
                <SideFilteringPanelMulticity v-if="showMulticity"
                    :Airlines="airlinesForFiltering"
                    :LoadingAirlines="loadingAirlines"
                    :LowestPrice="priceMinMaxForFiltering[0]"
                    :HighestPrice="priceMinMaxForFiltering[1]"
                    @SelectedAirlines="a=>selectedAirlines=a"
                    @RouteIndicator="r=>routeIndicator=r"
                    @PriceRange="p=>totalPriceFiltering=p"
                    @OutboundDepartureTimeRange="t=>outboundDepartureTimeFiltering=getDepartureTimeFiler(t)"
                    @ReturnDepartureTimeRange="t=>returnDepartureTimeFiltering=getDepartureTimeFiler(t)"
                    @FlightDuration="d=>flightDurationFiltering=d"
                />
                    </v-expansion-panel-content>
                </v-expansion-panel>                
                <SearchResultList v-if="flightFares!=null&&!showMulticity"
                    :FlightFares="flightFares" 
                    :AdultCount="passengerCountsByType.adultCount" 
                    :ChildCount="passengerCountsByType.childCount" 
                    :InfantCount="passengerCountsByType.infantCount"
                    :StudentCount="passengerCountsByType.studentCount"
                    :SelectedAirlines="selectedAirlines"
                    :RouteIndicator="routeIndicator"
                    :TotalPriceFilter="totalPriceFiltering"
                    :OutboundDepartureTimeFilter="outboundDepartureTimeFiltering"
                    :ReturnDepartureTimeFilter="returnDepartureTimeFiltering"
                    :FlightDuration="flightDurationFiltering"
                    :SearchId="searchId"
                />                
                <SearchResultListMulticity v-if="flightFares!=null&&showMulticity"
                    :FlightFares="flightFares" 
                    :AdultCount="passengerCountsByType.adultCount" 
                    :ChildCount="passengerCountsByType.childCount" 
                    :InfantCount="passengerCountsByType.infantCount"
                    :StudentCount="passengerCountsByType.studentCount"
                    :SelectedAirlines="selectedAirlines"
                    :RouteIndicator="routeIndicator"
                    :TotalPriceFilter="totalPriceFiltering"
                    :OutboundDepartureTimeFilter="outboundDepartureTimeFiltering"
                    :ReturnDepartureTimeFilter="returnDepartureTimeFiltering"
                    :FlightDuration="flightDurationFiltering"
                    :SearchId="searchId"
                    :searchPara="searchPara"
                />  
            </v-flex>
        </v-layout>
            <v-fab-transition>
              <v-btn
                v-show="showFloatingButton"
                color="primary"
                dark
                absolute
                bottom
                right
                fab
                fixed
                class="mb-5"
                @click="gotoTop()"
              >
                <v-icon>keyboard_arrow_up</v-icon>
              </v-btn>
            </v-fab-transition>
            <v-dialog
      v-model="showCopyLinkDialog"
      width="500"
      height="300"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Copy link
        </v-card-title>

        <v-card-text>
            <v-textarea :value="linkToCopy" outline background-color="#808080"></v-textarea>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="copyLinkDialogClick()"
            v-clipboard:copy="linkToCopy"
            v-clipboard:success="onCopyToClipboard"
            v-clipboard:error="onCopyToClipboardErr"
          >
            Copy
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>        
        <v-snackbar
            :top="true"
            :timeout="3000"
            v-model="snackbar.show"
            class="text-md-center"
            color="#ce971c"
        >{{snackbar.text}}
            <v-btn
                color="white"
                flat
                @click="snackbar.show = false"
            >
                Close
            </v-btn>
        </v-snackbar>       
    </v-container>
</template>

<script>
/* eslint-disable */
import theme from '../../theme'
import SearchResultList from './SearchResultList'
import SearchResultListMulticity from './SearchResultListMulticity'
import SearchBox from './SearchBox'
import MulticityBox from './MulticityBox'
import SideFilteringPanel from './SideFilteringPanel'
import SideFilteringPanelMulticity from './SideFilteringPanelMulticity'
import helper from '../helper'
import SearchBoxService from '../../services/searchBox.service'
import AgentTheme from '../../agent_theme';

export default {
    created(){
        this.wholesaleId= this.$route.params.wsid!=null? this.$route.params.wsid:0;
        this.urlId= this.$route.params.urlid!=null? this.$route.params.urlid:0;
        this.mlv= this.$route.params.mlv!=null? this.$route.params.mlv:0;
        this.searchCriteriaBase64 = this.$store.state.searchCriteriaBase64;
        this.searchCriteriaBase64M = this.$store.state.searchCriteriaBase64M;

        if(this.$store.state.triptype!=null){
            this.triptype = this.$store.state.triptype;
            this.passengerCountsByType.adultCount = this.$store.state.searchBoxValues.passengerCountByPax.adult;
            this.passengerCountsByType.childCount = this.$store.state.searchBoxValues.passengerCountByPax.child;
            this.passengerCountsByType.infantCount = this.$store.state.searchBoxValues.passengerCountByPax.infant;
            this.passengerCountsByType.studentCount = this.$store.state.searchBoxValues.passengerCountByPax.student;
            this.searchPara.trip=false;
            if(this.triptype=="M"){
            this.multicityselection=true;
            this.showMulticity=true;
            }else{
                this.showMulticity=false;
            }
            if(this.triptype=="R"){
                this.searchPara.trip=true;
            }
        }
        
        
        if (this.wholesaleId ==0){
            this.wholesaleId = this.$store.state.wholesaleId!=null? this.$store.state.wholesaleId:0;
        }

        if (this.urlId ==0){
            this.urlId = this.$store.state.urlId? this.$store.state.urlId:0;
        }

        if (this.mlv ==0){
            this.mlv = this.$store.state.mlv? this.$store.state.mlv:1;
        }

        this.$store.commit("updateWholesaleIdAndUrlId",[this.wholesaleId,this.urlId]);
        this.$store.commit("updateMarkupLevel",this.mlv);
        this.$vuetify.theme.primary.base = AgentTheme.getAgentTheme(this.wholesaleId).colors.primary.base;
        // this.getBackToHomeUrl();
    },
    props:[
        'selectedLanguage'
    ],
    components:{
        SearchBox,
        MulticityBox,
        SearchResultList,
        SearchResultListMulticity,
        SideFilteringPanel,
        SideFilteringPanelMulticity,
    },
    computed:{
        isMobile(){
            let isMobile = helper.display.isMobile(this.$vuetify.breakpoint.name);
            return isMobile;
        },
        showAlert(){
            return  this.flightFares==null&&(this.responseMessage!=null)
        },
        showFloatingButton(){
            return this.scrolling>200;
        },
        // showbtnAlert(){
        //     if(this.btnSubmitt==true){
        //         this.validation.showAlert = true;
        //         this.validation.message = "Button submitted";                
        //     }
        //     return this.btnSubmitt;
        // },
    },
    data(){
        return {
            mfilterPanel:[false],
            helper:helper,
            flightFares:null,
            passengerCountsByType:{
                adultCount:0,
                childCount:0,
                infantCount:0,
                studentCount:0,
            },
            responseMessage:null,
            defaultColors:{
                primary:theme.primary.base,
                secondary:theme.secondary
            },
            airlinesForFiltering:null,
            loadingAirlines:false,
            priceMinMaxForFiltering:[0,0],
            selectedAirlines:null,
            routeIndicator:'11',
            totalPriceFiltering:[0,100000000],
            outboundDepartureTimeFiltering:['00:00','23:59'],
            returnDepartureTimeFiltering:['00:00','23:59'],
            flightDurationFiltering:3000,
            searchId:null,
            selLang:this.$store.state.selectedLanguage,
            wholesaleId:"",
            urlId:"",
            searchCriteriaBase64:"",
            searchCriteriaBase64M:"",
            scrolling:0,
            mlv:1,
            triptype:"",
            showMulticity:false,
            multicityselection:false,
            showSearchBox:true,
            backToHomeUrl:"",
            copyLinkButton:false,
            validation:{
                showAlert:false,
                message:"",
            },
            searchPara:{                
                trip:"",                             
            },
            linkToCopy:"",
            showCopyLinkDialog:false,
            snackbar:{
                show:false,
                text:"",
            },
        }
    },
    methods:{
        onScroll(e){
            this.scrolling = e.target.defaultView.scrollY;
        },
        gotoTop(){
            helper.display.scrollToTop();
        },
        showSideFilteringPanel(){
            return 'md,lg,xl'.indexOf(this.$vuetify.breakpoint.name)>=0;
        },
        updateFlightFaresFromSearchBox(flightFares){
            if (flightFares==null||flightFares.length==0)this.selectedAirlines = null;
            this.flightFares=flightFares;
        },
        getDepartureTimeFiler(index){
            var timeSlots = new this.$linq(this.helper.dateAndTime.getTimeSlots(1,30));
            var timeText = timeSlots.where(s=>s.key==index.value[0]||s.key==index.value[1]).toArray();
            return [timeText[0].text,timeText[1].text];
        },
        loadmulticity(){
            this.validation.showAlert = false;            
            if(this.showMulticity){
                this.showMulticity=false;
                this.searchPara.trip=false;
            }else{
                this.showMulticity=true;
                this.searchPara.trip=false;
            }
            this.flightFares=null;
            this.selectedAirlines=null;
        },
        loadoneway(){
            this.validation.showAlert = false;
            this.showMulticity=false;
            this.multicityselection=false;
            this.flightFares=null;
            this.selectedAirlines=null;
        },
        getBackToHomeUrl(){
            SearchBoxService.getBackToHomeUrl().then((rslt=>{
                this.backToHomeUrl = rslt.data;
                if (this.backToHomeUrl.indexOf('http://')<0||
                this.backToHomeUrl.indexOf('https://')>0){
                    this.backToHomeUrl = "http://" + this.backToHomeUrl;
                }
            }));
        },
        copyLink() {
            SearchBoxService.getSharedSearchResultUrl().then((result)=>{
                //alert(result.data);
                this.linkToCopy = result.data;
                this.$copyText(result.data).then((e)=>{
                    this.snackbar.text = "Shared url coppied.";
                    this.snackbar.show = true;
                },(e)=>{
                    this.showCopyLinkDialog = true;
                });
                //
            });            
        },
        onCopyToClipboard(){
            this.showCopyLinkDialog = false;       
            setTimeout(() => {
                this.snackbar.text = "Shared url coppied.";
                this.snackbar.show = true;  
            }, 1000);   
        },
        onCopyToClipboardErr(){
            this.showCopyLinkDialog = false;
            setTimeout(() => {
                this.snackbar.text = "Cannot coppy.";
                this.snackbar.show = true;  
            }, 1000);                       
        },
        copyLinkDialogClick(){
            this.showCopyLinkDialog = false;
        },
    }
}
</script>

<style>

</style>
